<template>
  <div
    class="--row h5"
    :class="{'--full-width': isFullWidth}"
  >
    <div class="--label">
      <div ref="refLabelDiv" v-html="label"/>
    </div>
    <div
      class="--value"
      :class="{'--value_decoration': isCharFromRedactor}"
    >
      <div
        ref="refValueDiv"
        v-html="value"
        :class="{
          '--gap': isValuesGap,
          '--more': isFullOpen,
        }"
      />

      <template v-if="labelButtonMore && !isFullOpen">
        <div class="--open-button">
          <div @click="changeFullOpen">
            {{ labelButtonMore }}
            <img src="~/assets/img/svg/common/arrow-down.svg" alt=""/>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  label: {
    type: String,
    default: false,
  },
  value: {
    type: String,
    default: false,
  },
  isValuesGap: {
    type: Boolean,
    default: false
  },
  isFullWidth: {
    type: Boolean,
    default: false
  },
  labelButtonMore: {
    type: String,
    default: '',
  },
  isCharFromRedactor: {
    type: Boolean,
    default: false
  }
});

const refLabelDiv: any = ref(null);
const refValueDiv: any = ref(null);

const isFullOpen: Ref<boolean> = ref(false);
const changeFullOpen = () => {
  isFullOpen.value = !isFullOpen.value;
};

onMounted(() => {
  const labelDivHeight = refLabelDiv.value?.getBoundingClientRect().height;

  if (labelDivHeight <= 20) {

  }

  const pt = labelDivHeight - 20;
  refValueDiv.value.style.paddingTop = `${pt}px`;
});
</script>

<style lang="scss">
.--value_decoration {
  a {
    text-decoration: underline;
    transition: opacity 0.1s ease-in-out;
    &:hover {
      opacity: 0.8;
      text-decoration: none;
    }
  }
}
</style>
